import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface Props {
  open: boolean
  vin?: string
  onCancel: () => void
  onConfirm: () => void
}

export function DeleteVehicleModal({ open, vin, onCancel, onConfirm }: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Smazat vozidlo</DialogTitle>
          <DialogDescription>
            {vin ? <>Opravdu smazat vozidlo <strong>{vin}</strong>?</> : 'Opravdu smazat vozidlo?'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Zrušit
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Smazat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
